export default "__VITE_ASSET__ouKj0Z$H__"